var Item = /** @class */ (function () {
    function Item(name, colorGroup, laundryCategory, packingCategory, subcategory, idContainer, image, id) {
        this.id = id;
        this.name = name;
        this.colourGroup = colorGroup;
        this.laundryCategory = laundryCategory;
        this.packingCategory = packingCategory;
        this.subcategory = subcategory;
        this.idContainer = idContainer;
        this.image = image || null;
    }
    return Item;
}());
export default Item;
export var ColourGroup;
(function (ColourGroup) {
    ColourGroup[ColourGroup["White"] = 0] = "White";
    ColourGroup[ColourGroup["Black"] = 1] = "Black";
    ColourGroup[ColourGroup["Dark"] = 2] = "Dark";
    ColourGroup[ColourGroup["Light"] = 3] = "Light";
    ColourGroup[ColourGroup["Multicolour"] = 4] = "Multicolour";
})(ColourGroup || (ColourGroup = {}));
export var LaundryCategory;
(function (LaundryCategory) {
    LaundryCategory[LaundryCategory["Delicate"] = 0] = "Delicate";
    LaundryCategory[LaundryCategory["Sport"] = 1] = "Sport";
    LaundryCategory[LaundryCategory["Cotton"] = 2] = "Cotton";
    LaundryCategory[LaundryCategory["Wool"] = 3] = "Wool";
    LaundryCategory[LaundryCategory["Linen"] = 4] = "Linen";
    LaundryCategory[LaundryCategory["Alergic"] = 5] = "Alergic";
    LaundryCategory[LaundryCategory["Regular"] = 6] = "Regular";
})(LaundryCategory || (LaundryCategory = {}));
export var PackingCategory;
(function (PackingCategory) {
    PackingCategory[PackingCategory["Underwear"] = 0] = "Underwear";
    PackingCategory[PackingCategory["Socks"] = 1] = "Socks";
    PackingCategory[PackingCategory["Shirts"] = 2] = "Shirts";
    PackingCategory[PackingCategory["Trousers"] = 3] = "Trousers";
    PackingCategory[PackingCategory["Shoes"] = 4] = "Shoes";
    PackingCategory[PackingCategory["Jacket"] = 5] = "Jacket";
    PackingCategory[PackingCategory["Skirts"] = 6] = "Skirts";
    PackingCategory[PackingCategory["Accessories"] = 7] = "Accessories";
    PackingCategory[PackingCategory["Other"] = 8] = "Other";
})(PackingCategory || (PackingCategory = {}));
// export enum



//////////////////
// WEBPACK FOOTER
// ./src/models/Item.ts
// module id = null
// module chunks = 